import sthetoscopeBgImage from "../../assets/sthetoscope.jpg";

const styles = theme => ({
  volunteerForm: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100vw",
    height: "100%",
    minHeight:"100vh",
    backgroundImage: `url(${sthetoscopeBgImage})`,
    backgroundSize: "cover"
  },
  appHeader: {
    position: "absolute"
  },
  root: {
    display: 'flex',
    flexDirection:"column",
    alignItems:"center",
    width:"90%",
    height:"auto",
    paddingBottom:"20px"
  },
  rootForm: {
    display: 'flex',
    flexDirection:"column",
    alignItems:"center",
    width:"100%",
    height:"auto",
    paddingBottom:"20px"
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  formTitle: {
    marginTop: 15,
    marginBottom: 15,
    fontFamily: "Roboto, sans-serif",
    fontSize: "1.8rem"
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth:"800px",
    width: "88%",
    height: "100%",
    marginTop: 75,
    marginBottom: 75,
    paddingTop: 15,
    paddingBottom: 45,
    paddingLeft: 20,
    paddingRight: 20
  },
  calendar: {
    flex: 1,
    width: "90%",
    
  }
});

export default styles;
